import React, { useContext } from "react";
import { CartContext } from "../../ContextAPI";


const QtyContainer = ({ data }) => {
  const { handleInc, handleDec } = useContext(CartContext);

  return (
    <div className="inline-flex items-center rounded-lg border border-slate-300 bg-white">
      <button className="h-9 w-9 text-lg hover:bg-slate-100" onClick={() => handleDec(data.id)} aria-label="Decrease quantity">−</button>
      <p className="w-9 text-center text-sm font-semibold">{data.qty}</p>
      <button className="h-9 w-9 text-lg hover:bg-slate-100" onClick={() => handleInc({ ...data, qty: 1 })} aria-label="Increase quantity">+</button>
    </div>
  );
};

export default QtyContainer;
